import React from "react";
import { Zap } from "lucide-react";

const StickyCTA = () => {
  const [isVisible, setIsVisible] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 600);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToContact = (e) => {
    e.preventDefault();
    document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <button
      onClick={scrollToContact}
      className={`sticky-cta flex items-center gap-2 bg-[#FFD84D] text-black font-bold px-6 py-4 rounded-full transition-all duration-300 hover:bg-[#FFEA8A] hover:scale-105 ${
        isVisible
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-10 pointer-events-none"
      }`}
      data-testid="sticky-cta-button"
      aria-label="Få en stasjon hos deg"
    >
      <Zap className="w-5 h-5" />
      <span className="hidden sm:inline">Få en stasjon hos deg</span>
    </button>
  );
};

export default StickyCTA;
